export function initTabMenu(): void {
    const tabMenus = document.querySelectorAll<HTMLElement>(".block-tab-menu-mobile");

    tabMenus.forEach(tabMenu => {
        tabMenu.addEventListener("click", () => {
            const nextElement = tabMenu.nextElementSibling as HTMLElement | null;
            if (!nextElement) return;

            // Toggle visibility with simple animation-like effect
            if (nextElement.style.display === "none" || getComputedStyle(nextElement).display === "none") {
                nextElement.style.display = "flex";
                tabMenu.classList.add("open");
            } else {
                nextElement.style.display = "none";
                tabMenu.classList.remove("open");
            }
        });
    });
}